
// @ts-nocheck


export const localeCodes =  [
  "en",
  "ur"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_45US_46ts_401179fd",
      load: () => import("#nuxt-i18n/401179fd" /* webpackChunkName: "locale_en_45US_46ts_401179fd" */),
      cache: true
    }
  ],
  ur: [
    {
      key: "locale_ur_45URD_46ts_fd6fe9aa",
      load: () => import("#nuxt-i18n/fd6fe9aa" /* webpackChunkName: "locale_ur_45URD_46ts_fd6fe9aa" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    jit: true,
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      iso: "en-US",
      name: "ENGLISH 🇺🇸",
      dir: "ltr",
      files: [
        "/home/musman1/workspace/FixSirat-Admin/fixsirat-admin-frontend/i18n/lang/en-US.ts"
      ]
    },
    {
      code: "ur",
      iso: "ur-PK",
      name: "URDU 🇵🇰",
      dir: "rtl",
      files: [
        "/home/musman1/workspace/FixSirat-Admin/fixsirat-admin-frontend/i18n/lang/ur-URD.ts"
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "./lang",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_cookie_locale",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    iso: "en-US",
    name: "ENGLISH 🇺🇸",
    dir: "ltr",
    files: [
      {
        path: "/home/musman1/workspace/FixSirat-Admin/fixsirat-admin-frontend/i18n/lang/en-US.ts",
        cache: undefined
      }
    ]
  },
  {
    code: "ur",
    iso: "ur-PK",
    name: "URDU 🇵🇰",
    dir: "rtl",
    files: [
      {
        path: "/home/musman1/workspace/FixSirat-Admin/fixsirat-admin-frontend/i18n/lang/ur-URD.ts",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/